import React, { useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import {API_BASE_URL} from "../../apiConfig.jsx";
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc';
import {strEncode,strDecode} from '../../encrpt';
import DataTable from 'react-data-table-component';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";


function Usermanage() {
    const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");
        //console.log("authToken",authToken)
		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);
	
	const [formData, setFormData] = useState({
		c_name: "",
		c_username: "",
		c_email: "",
		c_password: "",
		n_phone_no: "",
		n_user_type: "",
		n_status: "0",
	  });
	  
	
	 const [errors, setErrors] = useState({});
     const [usertype, setUserTypeList] = useState([]);
	 const [internes, setRaporteeList] = useState([]);
	  const [composants, setComponentList] = useState([]);
	 const [columns, setColumns] = useState([]);
	const [tabledata, settableData] = useState([]);	
	const [selectedUser, setSelectedUser] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [modalData, setModalData] = useState(false);
  const [activeTab, setActiveTab] = useState("default-tab-1"); // Tracks active tab
  const [indiid, setModalId] = useState(null);	
  const [raporteedata, setRapporteeData] = useState({
	n_stakeholder_id : ""
  });

   const [componentdata, setComponentData] = useState({
	n_components_id : ""
  });
  useEffect(() => {
	// Switch to "Ajouter un nouvel utilisateur" tab if edit mode is enabled
	if (editMode) {
	  setActiveTab("default-tab-2");
	//setEditMode(false)
	} else {
	  setActiveTab("default-tab-1");
	}
  }, [editMode]);
  
  useEffect(() => {
	axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_user_type_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setUserTypeList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('stakeholder_reporting'),cols :strEncode("id,CONCAT(level_1, ' >> ', level_2, ' >> ', level_3, ' >> ', level_4) as c_name")},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setRaporteeList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('component_master'),cols :strEncode("id,CONCAT(pdo, ' >> ', component, ' >> ', sub_component) as c_name")},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setComponentList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_user_mst'),cols:strEncode('id as id, c_name as nom ,c_username as `nom d utilisateur`, c_email as email,n_phone_no  as `numéro de contact`,n_user_type_name as `type d utilisateur` ,Date(createdAt) as créé') },{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					if (!res.data || !res.data || res.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: row => row[key] // Show normal column data
					  }));

					  formattedColumns.push({
						name: "Actions",
						cell: (row) => (
							<div>
						  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
						  Modifier
						  </button>
						   <button className="btn btn-danger btn-sm" data-bs-toggle="modal"
											data-bs-target="#modalPosBooking"
											onClick={() => handleModalOpen(row)}>
							Liaison des rapports d'alerte						  </button>
							<button className="btn btn-primary btn-sm" data-bs-toggle="modal"
											data-bs-target="#modalComponents"
											onClick={() => handleModalComponents(row)}>
							Liaison des composants				  </button></div>
						),
					  });
					//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data);					
				  }).catch(error => {
					console.error("API Error:", error);
				  });
  }, []);
	
const tabActive = async (user) => {
	setFormData({
		c_name: "",
		c_username: "",
		c_email: "",
		c_password: "",
		n_phone_no: "",
		n_user_type: "",
		n_status: "",
	  });
  
	 setEditMode(false);
	 setSelectedUser(null);
}

const closeModal = () => {
	setModalData([]);
   }

   const handleMultiSelectChange = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
    setRapporteeData((prevData) => ({
         ...prevData,
         n_stakeholder_id: selectedOptions, // Store multiple values as an array
	     n_user : selectedUser.id
    }));
};


 const handleMultiComponentChange = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
    setComponentData((prevData) => ({
         ...prevData,
         n_components_id: selectedOptions, // Store multiple values as an array
	     n_user : selectedUser.id
    }));
};


  const handleEdit = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);
	try {
	  const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
		t: strEncode('pmis_user_mst'),
		cols : 	strEncode('*'),	
		whrc : strEncode('id = '+user.id+''),
	  }, { headers: { 'Content-Type': 'application/json' } });
  
	 // console.log("getuserdata", response.data);
	 // setFormData(response.data[0]); // Assuming data comes as an array
	 setFormData({
		id : response.data[0].id,
		c_name: response.data[0].c_name,
		c_username: response.data[0].c_username,
		c_email: response.data[0].c_email,
		c_password: "",
		n_phone_no: response.data[0].n_phone_no,
		n_user_type: response.data[0].n_user_type,
		n_status: response.data[0].n_status,
	  });

	} catch (error) {
	  console.error("Error fetching user data:", error);
	}
	setEditMode(true);
	setActiveTab("default-tab-2");
  };
  const handleModalOpen = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);	
    setModalId(user.id)
	try {
        // Fetch existing user data (Assuming you retrieve `n_stakeholder_id` from API)
        const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
            t: strEncode('pmis_rapports_user_linking_mst'),
            cols: strEncode('n_stakeholder_id'),
            whrc: strEncode(`n_user = ${user.id}`),
        }, { headers: { 'Content-Type': 'application/json' } });
        //console.log("reasponse",response.data)
		if (response.data.length > 0) {
			setRapporteeData({
				n_stakeholder_id: response.data.map((item) => String(item.n_stakeholder_id)) // Ensure array of strings
			});
		} else {
			setRapporteeData({ n_stakeholder_id: [] }); // Default to empty array
		}
    } catch (error) {
        console.error("Error fetching stakeholder data:", error);
        setRapporteeData({ n_stakeholder_id: "" });
    }
  
  };

   const handleModalComponents = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);	
    setModalId(user.id)
	try {
        // Fetch existing user data (Assuming you retrieve `n_stakeholder_id` from API)
        const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
            t: strEncode('pmis_components_user_linking_mst'),
            cols: strEncode('n_components_id'),
            whrc: strEncode(`n_user = ${user.id}`),
        }, { headers: { 'Content-Type': 'application/json' } });
        //console.log("reasponse",response.data)
		if (response.data.length > 0) {
			setComponentData({
				n_components_id: response.data.map((item) => String(item.n_components_id)) // Ensure array of strings
			});
		} else {
			setComponentData({ n_components_id: [] }); // Default to empty array
		}
    } catch (error) {
        console.error("Error fetching stakeholder data:", error);
        setComponentData({ n_components_id: "" });
    }
  
  };
  

  const handleUpdate = async () => {
    if (!formData.id) {
      alert("Invalid User ID!");
      return;
    }
    try {
      await axios.put(`${API_BASE_URL}/api/user/update/${formData.id}`, formData);
      alert("User details updated successfully!");
      setEditMode(false);
      setSelectedUser(null);
      //window.location.reload(); // Refresh DataTable
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };



    // console.log("usertyoe",usertype)
	  const userstatus = [
		{ id: 0, c_name: "Actif" },
		{ id: 1, c_name: "Inactif" },
	  ];

	  const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	  };
	
	  const validatePassword = (password) => {
		return {
		  length: password.length >= 12,
		  uppercase: /[A-Z]/.test(password),
		  number: /\d/.test(password),
		  specialChar: /[~_!@#^()-+|.,]/.test(password),
		  restrictedChars: !/[&\/\\$%'"`=:;*?<>{}]/.test(password),
		};
	  };
	
	
	 /* const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
		  newErrors[name] = "This field is required.";
		} else {
		  delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
		  newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" ) {
		  const validations = validatePassword(value);
		  if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
		  if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
		  if (!validations.number) newErrors[name] = "Password must contain at least one number.";
		  if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
		  if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	  }; */
	

	  const handleChange = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
			newErrors[name] = "This field is required.";
		} else {
			delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
			newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" && value) { // Only validate if password is entered
			const validations = validatePassword(value);
			if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
			if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
			if (!validations.number) newErrors[name] = "Password must contain at least one number.";
			if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
			if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	};
	  const handleSubmit = async (e) => {
		e.preventDefault();
	   
		let newErrors = {};
		
		// Check for empty fields
		if (!editMode) {
		Object.keys(formData).forEach((key) => {
		  if (!formData[key]) {
			newErrors[key] = "This field is required.";
		  }
		});
	} else {
		// Check for empty fields (except password in edit mode)
		Object.keys(formData).forEach((key) => {
			if (!formData[key] && key !== "c_password") { 
			  newErrors[key] = "This field is required.";
			}
		  });
		}
		
		if (!editMode) {
		// Enforce password validation before submitting
		const validations = validatePassword(formData.c_password);
		if (!validations.length) newErrors["c_password"] = "Password must be at least 12 characters.";
		if (!validations.uppercase) newErrors["c_password"] = "Password must contain at least one uppercase letter.";
		if (!validations.number) newErrors["c_password"] = "Password must contain at least one number.";
		if (!validations.specialChar) newErrors["c_password"] = "Password must contain at least one special character.";
		if (!validations.restrictedChars) newErrors["c_password"] = "Password contains restricted characters.";
		}

		if (!editMode) {
		// If there are validation errors, stop submission
		if (Object.keys(newErrors).length > 0) {
		  setErrors(newErrors);
		  return;
		}
	}
		console.log("formdata",formData)
		try {
		  console.log("formdata afeter",formData)
		  var response;
		  if (!editMode) {
			response = await axios.post(`${API_BASE_URL}/api/user/signup`, { data: formData });
			alert("Data saved successfully!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  } else {
			response = await axios.put(`${API_BASE_URL}/api/user/updateuser`, { data: formData });
			alert("User updated successfully!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  }
		   // Reset formData state
		   setFormData({
			c_name: "",
			c_username: "",
			c_email: "",
			c_password: "",
			n_phone_no: "",
			n_user_type: "",
			n_status: "",
		  });
	  
		 
		} catch (error) {
		  console.error("Error saving data:", error);
		}
	  };

	    const handleSubmitRaportee = async (e) => {
		 e.preventDefault();
		 var response = await axios.post(`${API_BASE_URL}/api/user/rapports/linkcreate`, { data: raporteedata },{ headers: { 'Content-Type': 'application/json' } });
		 if(response)
		 {		
		 alert("user linked Successfully");
		 }
		 setRapporteeData({
			n_stakeholder_id: ""
		  });
		  setSelectedUser(null);
		  window.location.reload(); // Refresh DataTable
	     };


        const handleSubmitComponent = async (e) => {
		 e.preventDefault();
		 var response = await axios.post(`${API_BASE_URL}/api/user/components/composantcreate`, { data: componentdata },{ headers: { 'Content-Type': 'application/json' } });
		 if(response)
		 {		
		 alert("user linked Successfully");
		 }
		 setComponentData({
			n_components_id: ""
		  });
		  setSelectedUser(null);
		  window.location.reload(); // Refresh DataTable
	     };

	     const exportData = (type) => {
		 const ws = XLSX.utils.json_to_sheet(tabledata);
		 const wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		 if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">Administration</Link></li>
				<li className="breadcrumb-item active">Gérer les utilisateurs</li>
			</ol>
			<h1 className="page-header">Administration <small>Créer des utilisateurs ici</small></h1>
			<Panel>
				<PanelHeader>Créer des utilisateurs ici</PanelHeader>
				<PanelBody>
				<div className="row">
				<div className="col-xl-12">
				<ul className="nav nav-pills">
        <li className="nav-item">
          <a
            href="#default-tab-1"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-1" ? "active" : ""}`}
            onClick={() => setActiveTab("default-tab-1")}
          >
            <span className="d-sm-block d-none">Liste des utilisateurs</span>
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#default-tab-2"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-2" ? "active" : ""}`}
            onClick={() => tabActive("default-tab-2")}
          >
            <span className="d-sm-block d-none">Ajouter un nouvel utilisateur</span>
          </a>
        </li>
      </ul>
					<div className="tab-content panel rounded-0 p-3 m-0">
					<div className={`tab-pane fade ${activeTab === "default-tab-1" ? "active show" : ""}`} id="default-tab-1">
						<button onClick={() => exportData("xlsx")} className="btn btn-success">
								Exporter Excel
								</button>
							<DataTable
									title="Données des utilisateurs"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>

								
						</div>
						<div className={`tab-pane fade ${activeTab === "default-tab-2" ? "active show" : ""}`} id="default-tab-2">
							<form method="post" onSubmit={handleSubmit}>
								{[
									{ label: "Nom", name: "c_name", type: "text" },
									{ label: "Nom d'utilisateur", name: "c_username", type: "text" },
									{ label: "Email", name: "c_email", type: "email" },
									{ label: "Mot de passe", name: "c_password", type: "password" },
									{ label: "Numéro de contact", name: "n_phone_no", type: "number" },
								].map((field) => (
									<div className="row mb-15px" key={field.name}>
									<label className="form-label col-form-label col-md-3">{field.label}</label>
									<div className="col-md-9">
									{field.name === "c_password" && editMode ? (
        <input
          className="form-control mb-5px"
          type={field.type}
          name={field.name}
          placeholder="Laisser vide si inchangé"        
          onChange={handleChange}
        />
      ) : (
        <input
          className="form-control mb-5px"
          type={field.type}
          name={field.name}
          value={formData[field.name]}
          onChange={handleChange}
        />
      )}
										{errors[field.name] && <span style={{ color: "red" }}>{errors[field.name]}</span>}
									</div>
									</div>
								))}

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">Type d'utilisateur</label>
									<div className="col-md-9">
									<select name="n_user_type" className="form-select" onChange={handleChange} value={formData.n_user_type}>
										<option value="">sélectionner le type d'utilisateur</option>
										{usertype.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_user_type && <span style={{ color: "red" }}>{errors.n_user_type}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">Statut de l'utilisateur</label>
									<div className="col-md-9">
									<select name="n_status" className="form-select" onChange={handleChange} value={formData.n_status}>
									<option value="">sélectionner le statut de l'utilisateur</option>
										{userstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_status && <span style={{ color: "red" }}>{errors.n_status}</span>}
									</div>
								</div>
                                {!editMode ?
								<button type="submit"  className="btn btn-success w-100px">Save</button>
								:
								<button type="submit" className="btn btn-success w-100px">Update</button> }
								</form>
						</div>
						
					</div>
					</div>
					
					</div>
				</PanelBody>
			</Panel>
			<div className="modal modal-pos fade" id="modalPosBooking">
				<div className="modal-dialog modal-lg" style={{maxWidth:"95%"}}>
					<div className="modal-content border-0">
						<div>
							<div className="p-0">
							<form onSubmit={handleSubmitRaportee}>								
    <div className="modal-body">
        <div className="d-flex align-items-center mb-3">
            <h4 className="modal-title d-flex align-items-center">
                <i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i>
            </h4>
            <a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
        </div>
        <div className="row">
            <div className="row mb-15px">
                <label className="form-label col-form-label col-md-3">Rapports Internes</label>
                <div className="col-md-9">
                    {/* Enable multi-select functionality */}
                    <select 
                        name="n_stakeholder_id"
                        className="form-select"
						style={{height:"500px"}}
                        multiple // Enables multi-selection
                        onChange={handleMultiSelectChange} 
                        value={Array.isArray(raporteedata.n_stakeholder_id) ? raporteedata.n_stakeholder_id : []}                    >
                        <option value="" disabled>Sélectionnez Rapport Interne</option>
                        {internes.map((option) => (
                            <option value={option.id} key={option.id}>{option.c_name}</option>
                        ))}
                    </select>
                    
                </div>
            </div>
        </div>
    </div>
    <div className="modal-footer">									
        <button type="submit" className="btn btn-success w-100px">Save</button>
    </div>
</form>


							</div>
						</div>
					</div>
				</div>
			</div>

               
<div className="modal modal-pos fade" id="modalComponents">
				<div className="modal-dialog modal-lg" style={{maxWidth:"95%"}}>
					<div className="modal-content border-0">
						<div>
							<div className="p-0">
							<form onSubmit={handleSubmitComponent}>								
    <div className="modal-body">
        <div className="d-flex align-items-center mb-3">
            <h4 className="modal-title d-flex align-items-center">
                <i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i>
            </h4>
            <a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
        </div>
        <div className="row">
            <div className="row mb-15px">
                <label className="form-label col-form-label col-md-3">Liaison des composants</label>
                <div className="col-md-9">
                    {/* Enable multi-select functionality */}
                    <select 
                        name="componentdata"
                        className="form-select"
						style={{height:"500px"}}
                        multiple // Enables multi-selection
                        onChange={handleMultiComponentChange} 
                        value={Array.isArray(componentdata.n_components_id) ? componentdata.n_components_id : []}                    >
                        <option value="" disabled>Sélectionnez composants</option>
                      
						{composants.map((option) => (
							<option
							value={option.id}
							key={option.id}
							style={{
								whiteSpace: "normal",   // allow wrapping
								wordWrap: "break-word", // break long words if needed
							}}
							>
							{option.c_name}
							</option>
						))}

                    </select>
                    
                </div>
            </div>
        </div>
    </div>
    <div className="modal-footer">									
        <button type="submit" className="btn btn-success w-100px">Save</button>
    </div>
</form>


							</div>
						</div>
					</div>
				</div>
			</div>



		</div>
	)
}

export default Usermanage;